import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class TelaUserGrupoService {

  constructor(private http:HttpClient, private httpService:HttpService) { }

  searchGroups(data:any) {
   return this.http.get(API + '/accessProfile',{params:data});
  }

  searchUserGroups(data:any){
    //return this.http.get(API + '/accessRole',{params:data});
  }


  saveUserGroups(data:any, callback:Function, beforeRequest:Function, afterRequest:Function){
   // return this.httpService.doPost('/accessRoleProfile',data,callback, beforeRequest,afterRequest);
  }
}
